// extracted by mini-css-extract-plugin
export default {"spinner":"spinner__wpXXzsDe","spin":"spin__Q_8Srj3d","circle":"circle__dGq6VBR9","dash-offset":"dash-offset__LyI9Xy83"};